/* RESPONSIBLE TEAM: team-workflows */
import type HandoffToExternalTicket from 'embercom/models/operator/visual-builder/step/handoff-to-external-ticket';
import StepConfig, { type StepConfigParams } from '../step';

export default class HandoffToExternalTicketConfiguration extends StepConfig {
  declare step: HandoffToExternalTicket;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-external-ticket',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
